import Header from "../../component/Header"
import Main from "../../component/Main"
import './home.css'

const Home = () => {
  return (
    <><Header />
    <Main />
    </>
  )
}

export default Home